/*
  deleteNodeFromGraph.js
*/

// Util.
import getNodesThatCollapseForcefully from './getNodesThatCollapseForcefully';

/**
 * Deletes a node from a graph.
 * 
 * If the node is collapsed, it will delete all the nodes inside it.
 */
export default function deleteNodeFromGraph(graphData, node) {

  // Check if the node exists.
  if (!graphData.nodes.includes(node)) {
    return graphData;
  }

  // If the node is collapsed, delete everything that would be collapsed by this node.
  const deleteSet = new Set([node]);
  if (node._botech?.collapsed) {
    for (const nd of getNodesThatCollapseForcefully(graphData, node)) {
      deleteSet.add(nd);
    }
  }

  // Delete the nodes.
  return {
    ...graphData,
    nodes: graphData.nodes.filter(obj => !deleteSet.has(obj)),
    links: graphData.links.filter(obj => !deleteSet.has(obj.source) && !deleteSet.has(obj.target)),
  };
}
